import { render } from "./manage-authorised-signatories.html?vue&type=template&id=0f7ec29c&scoped=true&ts=true&external"
import script from "./manage-authorised-signatories.ts?vue&type=script&lang=ts&external"
export * from "./manage-authorised-signatories.ts?vue&type=script&lang=ts&external"

import "./manage-authorised-signatories.scss?vue&type=style&index=0&id=0f7ec29c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7ec29c"]])

export default __exports__